import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useThemeContext } from '../../contexts'

type Props = {
  title?: string
}

/**
 * Dynamically sets the page title in the document header.
 *
 * @param {string} title - The page title.
 */
export const DocumentTitle: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation()

  const { theme } = useThemeContext()
  const isEnabled = theme?.Title?.IsEnabled && theme?.IsEnabled
  const value = theme?.Title?.Value

  const pageTitle = title ? `${title} |` : ''
  const appTitle = isEnabled && value ? value : t('common.app.title')

  useEffect(() => {
    document.title = `${pageTitle} ${appTitle}`

    return () => {
      document.title = appTitle
    }
  })

  return null
}
